import AButton from './base/_button'
import ACheckbox from './base/_checkbox'
import AIcon from './base/_icon'
import AInput from './base/_input'
import APagination from './base/_pagination'
import ARadio from './base/_radio'

import NetsTab from './common/netsTab/NetsTab.vue'
import NoBinds from './common/noBinds/NoBinds.vue'
import NoResult from './common/noResult/NoResult.vue'
import PaperItem from './common/paperItem/PaperItem.vue'
import PayAgreement from './common/payments/PayAgreement.vue'
import PayModal from './common/payments/PayModal.vue'
import PayQrcode from './common/payments/PayQrcode.vue'
import Ranger from './common/ranger/Ranger.vue'
import Modal from './enroll/Modal.vue'

export {
  APagination,
  AButton,
  AInput,
  AIcon,
  PaperItem,
  Ranger,
  NoResult,
  NoBinds,
  Modal,
  ACheckbox,
  ARadio,
  NetsTab,
  PayModal,
  PayAgreement,
  PayQrcode
}
